import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Inspector } from './inspector';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { baseUrl, activeWoGateway } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class ActiveWoService {

  private url = baseUrl + activeWoGateway;

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getActiveWos(id: any): Observable<any[]> {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getActiveWos', item1: id })
    .pipe(
      catchError(this.handleError('getActiveWos', []))
    );
  }

  getSpecifications(waf: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getSpecifications', item1: waf })
    .pipe(
      catchError(this.handleError('getSpecifications', []))
    );
  }

  getContacts(waf: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getContacts', item1: waf })
    .pipe(
      catchError(this.handleError('getContacts', []))
    );
  }

  getAuthInsp(waf: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getAuthInsp', item1: waf })
    .pipe(
      catchError(this.handleError('getAuthInsp', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }

}
